












import {
  defineComponent, reactive, watch, computed,
} from '@vue/composition-api';

const CommonYearSelector = defineComponent({
  setup(props: any, context: any) {
    const date = new Date(Date.now());
    const year = date.getFullYear() + 5;
    const years = [];
    for (let i = year + 543; i > 2400; i -= 1) {
      years.push(i);
    }

    const _value = computed(() => props.value);

    return {
      _value,
      years,
    };
  },
  props: {
    value: {
      default() { return ''; },
    },
    label: {
      type: String,
      default() { return ''; },
    },
    placeholder: {
      type: String,
      default() { return 'เลือกปี'; },
    },
  },
});

export default CommonYearSelector;
